import {
	memoizedFetchSitePersonalization,
	memoizedFetchSiteUserPersonalization,
} from '@atlassian/jira-personalization-service';

const IS_RENOTIFY_MESSAGE_DISMISSED = 'is_renotify_message_dismissed';

const JSW_RENOTIFY_DISMISS_TRAIT =
	'jira-software_ui_button_clicked_dismissbutton_peoplemenu_first_time';

export type DismissTraitRequestProp = {
	cloudId: string;
	userId: string;
};
export const getIsRenotifyMessageDismissed = async ({
	cloudId,
	userId,
}: DismissTraitRequestProp) => {
	const localStorageValue = window.localStorage?.getItem(IS_RENOTIFY_MESSAGE_DISMISSED);
	if (localStorageValue === 'true' || localStorageValue === 'false') {
		return localStorageValue === 'true';
	}
	const response = await memoizedFetchSiteUserPersonalization({ cloudId, userId });
	const targetTraitValue = response.find(
		(traits) => traits.name === JSW_RENOTIFY_DISMISS_TRAIT,
	)?.value;
	if (targetTraitValue) {
		localStorage.setItem(IS_RENOTIFY_MESSAGE_DISMISSED, 'true');
	}
	return !!targetTraitValue;
};

const TIME_OF_LAST_RESEND_INVITATION = 'time_of_last_resend_invitation';
const JSW_SEND_REMIND_LAST_TRAIT =
	'jira-software_ui_button_clicked_sendreminderbutton_navigationnextscreen_last_time';

export const getTimeOfLastResendInvitation = async (cloudId: string) => {
	const localStorageValue = window.localStorage?.getItem(TIME_OF_LAST_RESEND_INVITATION);

	if (typeof localStorageValue === 'string') {
		const parsedLocalStorageValue = parseInt(localStorageValue, 10);
		if (!Number.isNaN(parsedLocalStorageValue)) {
			return parsedLocalStorageValue;
		}
	}

	const response = await memoizedFetchSitePersonalization({ cloudId });
	const targetTraitValue = response.find(
		(traits) => traits.name === JSW_SEND_REMIND_LAST_TRAIT,
	)?.value;
	if (typeof targetTraitValue === 'string') {
		const timeOfLastResend = new Date(targetTraitValue).getTime();
		localStorage.setItem(TIME_OF_LAST_RESEND_INVITATION, `${timeOfLastResend}`);
		return timeOfLastResend;
	}
	return 0;
};

export const hasAtLeast24HoursElapsed = (timeOfLastResendInvitation: number) => {
	const TWENTY_FOUR_HOURS_IN_MS = 24 * 60 * 60 * 1000;
	return Date.now() - timeOfLastResendInvitation >= TWENTY_FOUR_HOURS_IN_MS;
};
